import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sendButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 0,
    height: 'auto',
    marginLeft: 24,
    fontSize: 12,
    fontWeight: 600,
    '&:hover': {
      background: 'transparent'
    }
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.green_90
  },
  sendIcon: {
    width: 24,
    height: 24,
    marginRight: 6
  },
  disabledIcon: {
    opacity: 0.5
  },
  card: {
    backgroundColor: theme.colorPalette.beige_25,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 72,
    padding: '0 24px',
    marginBottom: 8
  },
  buttons: {
    display: 'flex'
  }
});

export default makeStyles(styles);
